import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { PageHeader } from "../components/PageHeader";

const inputCls = "w-full h-11 px-3 rounded-lg border border-slate-300 bg-white outline-none focus:border-slate-900 transition-colors";
const TZS = typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : ["UTC"];

export default function Settings() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch((e) => toast.error(errMsg(e))); }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await api.put("/settings", { ...s, grace_minutes: Number(s.grace_minutes) }); setS(r.data); toast.success("Settings saved"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  if (!s) return null;
  return (
    <>
      <PageHeader overline="Configuration" title="Settings" />
      <form onSubmit={save} className="bg-white border border-slate-200 rounded-xl p-6 md:p-8 max-w-xl space-y-6">
        <label className="block space-y-1.5">
          <span className="text-sm font-medium">Company name (shown on kiosk)</span>
          <input value={s.company_name} onChange={(e) => setS({ ...s, company_name: e.target.value })} data-testid="settings-company-name-input" className={inputCls} />
        </label>
        <label className="block space-y-1.5">
          <span className="text-sm font-medium">Late grace period (minutes)</span>
          <input type="number" min={0} max={240} value={s.grace_minutes} onChange={(e) => setS({ ...s, grace_minutes: e.target.value })} data-testid="settings-grace-minutes-input" className={`${inputCls} font-mono`} />
          <span className="text-xs text-slate-500">Check-ins after shift start + grace are marked Late.</span>
        </label>
        <label className="block space-y-1.5">
          <span className="text-sm font-medium">Timezone (used for dates, late & weekly off)</span>
          <select value={s.timezone} onChange={(e) => setS({ ...s, timezone: e.target.value })} data-testid="settings-timezone-select" className={inputCls}>
            {(TZS.includes(s.timezone) ? TZS : [s.timezone, ...TZS]).map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </label>
        <button disabled={busy} data-testid="settings-save-btn" className="h-11 px-8 rounded-full bg-slate-900 hover:bg-emerald-500 hover:text-slate-950 text-white font-semibold disabled:opacity-50 transition-colors">
          {busy ? "Saving…" : "Save settings"}
        </button>
      </form>
    </>
  );
}
